'use strict';

var jsxRuntime = require('react/jsx-runtime');

const WishketBlog = ({ testId, className })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: jsxRuntime.jsx("path", {
            d: "M5.6253 6.85714H8.28416C8.75239 6.85714 9.137 6.7451 9.438 6.52101C9.73901 6.29692 9.88951 5.93277 9.88951 5.42857C9.88951 5.14846 9.83934 4.91877 9.73901 4.7395C9.63867 4.56022 9.50489 4.42017 9.33767 4.31933C9.17045 4.21849 8.97535 4.15126 8.75239 4.11765C8.54057 4.07283 8.3176 4.05042 8.08349 4.05042H5.6253V6.85714ZM2.99988 2H8.61861C9.18717 2 9.70556 2.05042 10.1738 2.15126C10.642 2.2521 11.0434 2.42017 11.3778 2.65546C11.7123 2.87955 11.9687 3.18207 12.147 3.56303C12.3366 3.94398 12.4313 4.41457 12.4313 4.97479C12.4313 5.57983 12.292 6.08403 12.0133 6.4874C11.7457 6.89076 11.3444 7.22129 10.8092 7.47899C11.545 7.69188 12.0913 8.06723 12.448 8.60504C12.8159 9.13165 12.9999 9.77031 12.9999 10.521C12.9999 11.126 12.8828 11.6527 12.6487 12.1008C12.4146 12.5378 12.0969 12.8964 11.6955 13.1765C11.3053 13.4566 10.8538 13.6639 10.341 13.7983C9.83934 13.9328 9.32095 14 8.78583 14H2.99988V2ZM5.6253 11.9496H8.43466C8.69107 11.9496 8.93633 11.9272 9.17045 11.8824C9.40456 11.8263 9.6108 11.7423 9.78917 11.6303C9.96755 11.507 10.1069 11.3445 10.2072 11.1429C10.3187 10.9412 10.3745 10.6835 10.3745 10.3697C10.3745 9.7535 10.2017 9.31653 9.85606 9.05882C9.51047 8.78992 9.05339 8.65546 8.48483 8.65546H5.6253V11.9496Z",
            fill: "#9E9E9E"
        })
    });
};

module.exports = WishketBlog;
